import { z } from "zod";

const formSchema = z
    .object({
        firstName: z.string().min(1, { message: "First name is required" }),
        lastName: z.string().min(1, { message: "Last name is required" }),
        email: z.string().min(1, { message: "Email address is required" }).email(),
        contactNumber: z
            .string()
            .min(1, { message: "Phone number is required" })
            .max(11, { message: "Phone number must be no more than 11 characters" }),
        postCode: z
            .string()
            .max(8, { message: "Postcode must be no more than 8 characters" })
            .optional(),
        marketingConsent: z.boolean().default(false),
        contactSourceReason: z.string().default("Replace value here"),
        contactSourceActivityType: z.string().default("Website"),
    })
    .required();

export default formSchema;
